import {recentPortfolios, RecentPortfolios} from "./recent/RecentPortfolioComponent";

export default function(parentDir: string): string {

    const rootDir = `${parentDir}/portfolios`;

    return angular.module("tfApp.nav.components.portfolios", [])
                  .component(RecentPortfolios, recentPortfolios(rootDir))
                  .name;
}
